<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * Device List Page
 */
export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Device List",
      items: [],
      devicelist: [],
      devicesearch: "",
      selectdevicestatus: "-1",
      userinfo: null,
      loading: false,
      block: false,
      systemtype: 0,
      multipleDeviceSelection: [],
      loadingtext: "",
      pagesize: 20,
      currentPage: 1,
      scopeRetryAttempt: 0,
      statusOptions: [
        { label: this.$t("device.lists.all") || "全部", value: "-1" },
        { label: this.$t("device.lists.overdue") || "过期", value: "0" },
        { label: this.$t("device.lists.online") || "在线", value: "1" },
        { label: this.$t("device.lists.maintain") || "维护", value: "5" },
        { label: this.$t("device.lists.offline") || "离线", value: "9" },
      ],
    };
  },
  async mounted() {
    await this.$permissionManager.ensureReady();
    this.title = this.$t("menuitems.devices.lists");
    this.items = [
      {
        text: this.$t("menuitems.devices.text"),
        href: "/",
      },
      {
        text: this.$t("menuitems.devices.lists"),
        active: true,
      },
    ];

    try {
      this.userinfo = JSON.parse(localStorage.getItem("user"));
      if (!this.userinfo) {
        this.$message.error(this.$t("global.errors.loginrequired"));
        this.$router.push({ name: "login" });
        return;
      }
      this.block = !this.$hasPermission('device.delete');
    } catch (error) {
      console.error("解析用户信息失败:", error);
      this.$message.error(this.$t("global.errors.loginrequired"));
      this.$router.push({ name: "login" });
      return;
    }

    this.getdevicelist();
    this.getsysteminfo();
  },
  methods: {
    getsysteminfo() {
      this.$axios
        .post(
          this.apiuri,
          {
            action: "systeminfo",
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          if (response.data.status === 200 && response.data.data) {
            this.systemtype = parseInt(response.data.data.model) || 0;
          }
        })
        .catch((error) => {
          console.error("获取系统信息失败:", error);
        });
    },
    getdevicelist() {
      this.loading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "deviceslist",
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.loading = false;
          if (response.data.status === 200 || response.data.data) {
            this.devicelist = response.data.data || [];
            if (this.devicelist.length === 0) {
              this.warnIfEmptyDeviceScope(() => this.getdevicelist());
            }
          } else {
            this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.loaddata"));
            this.devicelist = [];
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("获取设备列表失败:", error);
          this.$message.error(this.$t("global.errors.network"));
          this.devicelist = [];
        });
    },
    setnostock(id) {
      this.$axios
        .post(
          this.apiuri,
          {
            action: "setnostock",
            id: id,
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          if (response.data.status === 200) {
            this.$message({
              message: this.$t("global.success"),
              type: "success",
            });
            this.getdevicelist();
          } else if (response.data.status === 403) {
            this.$message({
              message: this.$t("global.delete.auth"),
              type: "warning",
            });
          } else {
            this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.operation"));
          }
        })
        .catch((error) => {
          console.error("设置无库存失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    deletedevice(id) {
      this.$confirm(
        this.$t("global.delete.deletedevicetip"),
        this.$t("global.delete.sureyouaction"),
        {
          confirmButtonText: this.$t("global.button.ok"),
          cancelButtonText: this.$t("global.button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.$axios
            .post(
              this.apiuri,
              {
                action: "devicedelete",
                id: id,
              },
              {
                headers: { Openid: this.userinfo.openid },
              }
            )
            .then((response) => {
              if (response.data.status === 200) {
                this.$message({
                  message: this.$t("global.delete.success"),
                  type: "success",
                });
                this.getdevicelist();
              } else if (response.data.status === 403) {
                this.$message({
                  message: this.$t("global.delete.auth"),
                  type: "warning",
                });
              } else {
                this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.operation"));
              }
            })
            .catch((error) => {
              console.error("删除设备失败:", error);
              this.$message.error(this.$t("global.errors.network"));
            });
        })
        .catch(() => { });
    },
    devicecheckout(id, count = 1, index = 1) {
      this.loading = true;
      if (index > 0) {
        this.loadingtext = this.$t("device.list.checkouts", {
          index: index,
          count: this.multipleDeviceSelection.length,
        }) || `正在结账 ${index}/${count}`;
      } else {
        this.loadingtext = "";
      }

      this.$axios
        .post(
          this.apiuri,
          {
            action: "barcheckout",
            id: id,
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          if (count === index) {
            this.loading = false;
            this.loadingtext = "";
          }
          if (!response.data) {
            this.$message.error(this.$t("global.errors.operation"));
          } else if (response.data.status === 200) {
            if (count === index) {
              this.$message({
                message: this.$t("global.success"),
                type: "success",
              });
            }
          } else if (response.data.status === 404) {
            this.$message.error(this.$t("device.lists.offline"));
          } else {
            this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.operation"));
          }
        })
        .catch((error) => {
          console.error("设备结账失败:", error);
          if (count === index) {
            this.loading = false;
            this.loadingtext = "";
          }
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    openbeer(id) {
      this.loading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "openbar",
            id: id,
            route: [true, true, true, true, true, true],
            reset: true,
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.loading = false;
          if (!response.data) {
            this.$message.error(this.$t("global.errors.operation"));
          } else if (response.data.status === 200) {
            this.$message({
              message: this.$t("global.success"),
              type: "success",
            });
          } else if (response.data.status === 404) {
            this.$message.error(this.$t("device.lists.offline"));
          } else {
            this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.operation"));
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("开启设备失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    handleSelectionDevicesChange(val) {
      this.multipleDeviceSelection = val;
    },
    bathopenbar() {
      if (this.multipleDeviceSelection.length > 0) {
        this.multipleDeviceSelection.forEach((device) => {
          this.openbeer(device.id);
        });
      } else {
        this.$message.warning(this.$t("device.lists.select_device") || "请先选择设备");
      }
    },
    bathcheckout() {
      if (this.multipleDeviceSelection.length > 0) {
        this.loading = true;
        const count = this.multipleDeviceSelection.length;
        this.multipleDeviceSelection.forEach((device, index) => {
          const currentIndex = index + 1;
          const timeout = 1000 * currentIndex;
          setTimeout(() => {
            this.devicecheckout(device.id, count, currentIndex);
          }, timeout);
        });
      } else {
        this.$message.warning(this.$t("device.lists.select_device") || "请先选择设备");
      }
    },
    changeSort(val) {
      // 排序处理
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    refresh() {
      this.currentPage = 1;
      this.getdevicelist();
    },
    getDeviceStatusTag(row) {
      if (!row) {
        return { type: 'info', text: '-' };
      }

      // 使用宽松比较，兼容字符串和数字类型
      const status = row.status != null ? parseInt(row.status) : null;
      const online = row.online != null ? parseInt(row.online) : null;
      const errorCode = row.error_code != null ? parseInt(row.error_code) : null;
      
      // 状态 0: 过期
      if (status === 0 || status === '0') {
        return { type: 'warning', text: this.$t("device.lists.overdue") || "设备过期" };
      }
      
      // 状态 5: 维护
      if (status === 5 || status === '5') {
        return { type: 'danger', text: this.$t("device.lists.maintain") || "设备维护" };
      }
      
      // 状态 1: 正常状态，需要检查在线状态和错误码
      if (status === 1 || status === '1') {
        // 先检查是否有错误码（错误码优先级最高）
        if (errorCode && errorCode >= 31 && errorCode <= 37) {
          const errorKey = `device.error.error${errorCode}`;
          try {
            const errorText = this.$t(errorKey);
            // 如果翻译存在且不是键本身，使用翻译
            if (errorText && errorText !== errorKey) {
              return { type: 'danger', text: errorText };
            }
          } catch (e) {
            // 翻译失败，使用默认文本
          }
          return { type: 'danger', text: `错误 ${errorCode}` };
        }
        
        // 检查在线状态
        if (online === 1 || online === '1') {
          return { type: 'success', text: this.$t("device.lists.ok") || "设备正常" };
        }
        
        if (online === 0 || online === '0' || online === null || online === undefined) {
          return { type: 'danger', text: this.$t("device.lists.offline") || "设备离线" };
        }
      }
      
      // 默认状态
      return { type: 'info', text: this.$t("device.lists.status") || "未知" };
    },
  },
  computed: {
    searchindeviceslist() {
      let datas = this.devicelist;
      
      // 搜索过滤
      if (this.devicesearch) {
        const searchTerm = this.devicesearch.trim().toLowerCase();
        datas = datas.filter((value) => {
          return (
            (value.ED_id && value.ED_id.toLowerCase().includes(searchTerm)) ||
            (value.device_sn && value.device_sn.toLowerCase().includes(searchTerm)) ||
            (value.name && value.name.toLowerCase().includes(searchTerm))
          );
        });
      }
      
      // 状态过滤
      if (this.selectdevicestatus !== "-1") {
        const status = parseInt(this.selectdevicestatus);
        switch (status) {
          case 0:
            datas = datas.filter((value) => value.status === 0);
            break;
          case 1:
            datas = datas.filter((value) => value.online === 1);
            break;
          case 5:
            datas = datas.filter((value) => value.status === 5);
            break;
          case 9:
            datas = datas.filter((value) => value.online === 0);
            break;
        }
      }
      
      return datas;
    },
    paginatedDeviceList() {
      const start = (this.currentPage - 1) * this.pagesize;
      const end = start + this.pagesize;
      return this.searchindeviceslist.slice(start, end);
    },
    totalCount() {
      return this.searchindeviceslist.length;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <el-card class="box-card" v-loading="loading" :element-loading-text="loadingtext">
          <div slot="header" class="clearfix">
            <span>
              <i class="el-icon-s-grid"></i>
              {{ $t("menuitems.devices.lists") }}
            </span>
            <div style="float: right;">
              <el-button
                icon="el-icon-refresh"
                @click="refresh"
                :loading="loading"
                circle
                size="small"
              ></el-button>
            </div>
          </div>
          
          <!-- 搜索和筛选 -->
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="input-group">
                <el-input
                  v-model="devicesearch"
                  :placeholder="$t('device.lists.search')"
                  clearable
                  prefix-icon="el-icon-search"
                  @keyup.enter.native="devicesearch = devicesearch"
                ></el-input>
              </div>
            </div>
            <div class="col-md-4">
              <el-select
                v-model="selectdevicestatus"
                :placeholder="$t('device.lists.filter_status') || '筛选状态'"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="option in statusOptions"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                ></el-option>
              </el-select>
            </div>
            <div class="col-md-2 text-right">
              <span class="text-muted">
                {{ $t('global.text.total') }}: <strong>{{ totalCount }}</strong>
              </span>
            </div>
          </div>

          <!-- 批量操作 -->
          <div class="row mb-3" v-if="multipleDeviceSelection.length > 0">
            <div class="col-12">
              <el-alert
                :title="$t('device.lists.selected_count', { count: multipleDeviceSelection.length }) || `已选择 ${multipleDeviceSelection.length} 个设备`"
                type="info"
                :closable="false"
                show-icon
              >
                <template slot="default">
                  <el-button
                    type="primary"
                    size="small"
                    @click="bathopenbar"
                    style="margin-right: 10px"
                  >
                    {{ $t("device.button.batch_open") || "批量开台" }}
                  </el-button>
                  <el-button
                    type="primary"
                    size="small"
                    @click="bathcheckout"
                  >
                    {{ $t("device.button.batch_checkout") || "批量结账" }}
                  </el-button>
                </template>
              </el-alert>
            </div>
          </div>

          <!-- 表格 -->
          <el-table
            :data="paginatedDeviceList"
            border
            style="width: 100%"
            @selection-change="handleSelectionDevicesChange"
            @sort-change="changeSort"
            :default-sort="{ prop: 'ED_id', order: 'ascending' }"
            stripe
            :empty-text="$t('global.text.nodata') || '暂无数据'"
            show-overflow-tooltip
          >
            <el-table-column type="selection" width="55" align="center">
            </el-table-column>
            <el-table-column
              prop="ED_id"
              :label="$t('device.lists.id')"
              width="140"
              sortable
              :sort-orders="['ascending', 'descending']"
            >
            </el-table-column>
            <el-table-column prop="name" :label="$t('device.lists.name')" width="150" show-overflow-tooltip>
            </el-table-column>
            <el-table-column :label="$t('device.lists.version')" width="120" align="center">
              <template slot-scope="scope">
                <span>{{ $t("version." + scope.row.version) || scope.row.version }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('device.lists.status')" width="120" align="center">
              <template slot-scope="scope">
                <el-tag 
                  :type="getDeviceStatusTag(scope.row).type" 
                  size="small"
                >
                  {{ getDeviceStatusTag(scope.row).text }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column :label="$t('device.lists.action')" min-width="400">
              <template slot-scope="scope">
                <router-link :to="{
                  path: '/device/devicedetail',
                  query: { id: scope.row.id },
                }">
                  <el-button size="mini" type="primary" icon="el-icon-info" round>{{
                    $t("device.lists.info")
                  }}</el-button>
                </router-link>
                <el-button
                  type="primary"
                  size="mini"
                  round
                  @click="setnostock(scope.row.id)"
                  v-if="scope.row.nostock == 0"
                >
                  {{ $t("device.button.nostock1") }}
                </el-button>
                <el-button
                  type="danger"
                  size="mini"
                  round
                  @click="setnostock(scope.row.id)"
                  v-if="scope.row.nostock == 1"
                >
                  {{ $t("device.button.nostock2") }}
                </el-button>
                <template v-if="systemtype == 1 || scope.row.beermode == 2">
                  <router-link :to="{
                    path: '/device/baropen',
                    query: { id: scope.row.id },
                  }">
                    <el-button size="mini" type="success" icon="el-icon-circle-plus" round>{{
                      $t("device.button.openstage")
                    }}</el-button>
                  </router-link>
                  <el-button
                    size="mini"
                    type="primary"
                    icon="el-icon-video-play"
                    @click="openbeer(scope.row.id)"
                    round
                  >
                    {{ $t("device.button.onclickopenbar") }}
                  </el-button>
                  <router-link :to="{
                    path: '/device/barclose',
                    query: { id: scope.row.id },
                  }">
                    <el-button type="success" size="mini" icon="el-icon-circle-close" round>{{
                      $t("device.button.closestage")
                    }}</el-button>
                  </router-link>
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-s-finance"
                    round
                    @click="devicecheckout(scope.row.id)"
                  >
                    {{ $t("device.button.checkout") }}
                  </el-button>
                </template>
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  round
                  v-if="!block"
                  @click="deletedevice(scope.row.id)"
                >
                  {{ $t("device.lists.delete") }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="row mt-3" v-if="totalCount > 0">
            <div class="col-12">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pagesize"
                :current-page="currentPage"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                class="text-right"
              >
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.clearfix {
  font-weight: 500;
}

.clearfix i {
  margin-right: 5px;
}

.input-group {
  display: flex;
}
</style>